export default __webpack_public_path__ + "img/speedtest.25de4a7.svg";